import { environment, localization } from "@/lib/resources";
import $ from "jquery";

$(".cart-list__body")
	.find(".cart-list__amount input")
	.on("keyup", verfuegbarkeitPruefen)
	.on("change", verfuegbarkeitPruefen);

function verfuegbarkeitPruefen(e: JQuery.KeyUpEvent | JQuery.ChangeEvent) {
	let $lagerbestand = $(e.currentTarget)
		.closest("tr")
		.find(".cart-list__availability");

	$lagerbestand.removeClass("is-available");
	$lagerbestand.removeClass("is-demandable");

	let istProspekt = $(e.currentTarget).attr("data-prospekt-artikel");

	if (istProspekt === "True") {
		setLieferzeitProspekt($lagerbestand);
	} else {
		let gewaehlteMenge = parseInt($(e.currentTarget).val(), 10);
		let lagerbestandMenge = parseInt($(e.currentTarget).attr("data-lagerbestand") as string, 10);
		let lagerbestandKurzfristigBeschaffbarMenge = parseInt($(e.currentTarget).attr("data-lagerbestand-kurzfristig-beschaffbar") as string, 10);
		let lagerbestandLangfristigBeschaffbarMenge = parseInt($(e.currentTarget).attr("data-lagerbestand-langfristig-beschaffbar") as string, 10);
		let lagerbestandInklusiveGanterLagerCanada = $(e.currentTarget).data("lagerbestand-inklusive-ganter-lager-canada") as number;

		if (environment.landKuerzel == "ca"
			&& gewaehlteMenge > lagerbestandMenge
			&& gewaehlteMenge <= lagerbestandInklusiveGanterLagerCanada) {

			setLagerbestandInklusiveGanterLagerCanada($lagerbestand);
			return;
		}
		// Diese Logik liegt auch unter Ganter.Responsive.Entities.Lagerbestand.Lagerbestand.GetArtikelVerfuegbarkeit()
		// Wenn sich hier etwas ändert, muss das auf der Entity nachgezogen werden.
		let lagerSumme = lagerbestandMenge + lagerbestandKurzfristigBeschaffbarMenge;
		let lagerSummeMitDrittLager = lagerSumme + lagerbestandLangfristigBeschaffbarMenge;
		if (gewaehlteMenge < 1) {
			setPositionNichtLieferbar($lagerbestand);
		} else if (gewaehlteMenge <= lagerbestandMenge) {
			setPositionLieferbar($lagerbestand);
		} else if (gewaehlteMenge <= lagerSumme) {
			setPositionKurzfristigBeschaffbar($lagerbestand);
		} else if (gewaehlteMenge <= lagerSummeMitDrittLager) {
			setPositionLangfristigBeschaffbar($lagerbestand);
		} else {
			setPositionNichtLieferbar($lagerbestand);
		}
	}
}

function setPositionLieferbar(lagerbestandElement: JQuery<HTMLElement>) {
	lagerbestandElement.html(localization("artikelLagerbestandVerfuegbar"));
	lagerbestandElement.addClass("is-available");
}

function setPositionKurzfristigBeschaffbar(lagerbestandElement: JQuery<HTMLElement>) {
	lagerbestandElement.html(localization("artikelLagerbestandKurzfristigBeschaffbar"));
	lagerbestandElement.addClass("is-available");
}

function setPositionLangfristigBeschaffbar(lagerbestandElement: JQuery<HTMLElement>) {
	lagerbestandElement.html(localization("artikelLagerbestandLangfristigBeschaffbar"));
	lagerbestandElement.addClass("is-available");
}

function setPositionNichtLieferbar(lagerbestandElement: JQuery<HTMLElement>) {
	lagerbestandElement.html(localization("artikelLagerbestandAnfrage"));
	lagerbestandElement.addClass("is-demandable");
}

function setLieferzeitProspekt(lagerbestandElement: JQuery<HTMLElement>) {
	lagerbestandElement.addClass("is-available");
}

function setLagerbestandInklusiveGanterLagerCanada(lagerbestandElement: JQuery<HTMLElement>) {
	lagerbestandElement.html(localization("artikelLagerbestandInklusiveGanterLagerCanada"));
	lagerbestandElement.addClass("is-available");
}
